import { __decorate, __metadata, __param } from "tslib";
import { IAuthDomainService } from '../auth/service/auth-domain-service.interface';
import { ClientVarsProxy } from './client-vars-proxy/client-vars-proxy';
import { IDocMetaDomainService } from '../doc-meta/service/doc-meta-domain-service.interface';
import { IUserInfoDomainService } from '../user-info/service/user-info-domain-service.interface';
var DomainUpdater = /** @class */ (function () {
    function DomainUpdater(docMetaDomainService, authDomainService, userInfoDomainService) {
        this.docMetaDomainService = docMetaDomainService;
        this.authDomainService = authDomainService;
        this.userInfoDomainService = userInfoDomainService;
    }
    /**
     * 更新clientVars里的数据
     * @param clientVars
     * @param buildProxy
     */
    DomainUpdater.prototype.updateDomainWithClientVars = function (clientVars, buildProxy) {
        if (buildProxy === void 0) { buildProxy = false; }
        this.docMetaDomainService.updateWithClientVars(clientVars);
        this.authDomainService.updateWithClientVars(clientVars);
        this.userInfoDomainService.updateWithClientVars(clientVars);
        if (buildProxy) {
            ClientVarsProxy.createClientVarsToDomainProxy(this.docMetaDomainService, this.authDomainService, this.userInfoDomainService, clientVars);
        }
    };
    DomainUpdater.prototype.updateDomainWithRequests = function (requestParam) {
        this.docMetaDomainService.init(requestParam);
        this.authDomainService.init(requestParam);
        this.userInfoDomainService.init(requestParam);
    };
    DomainUpdater = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, IAuthDomainService),
        __param(2, IUserInfoDomainService),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], DomainUpdater);
    return DomainUpdater;
}());
export { DomainUpdater };
